/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountries200,
  GetApiV1LocationCountries401,
  GetApiV1LocationCountries500,
  GetApiV1LocationCountriesQueryResponse,
} from "../../types/locationCountryController/GetApiV1LocationCountries.ts";
import { countryViewModelSchema } from "../countryViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountries200Schema = z.array(
  z.lazy(() => countryViewModelSchema),
) as unknown as ToZod<GetApiV1LocationCountries200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountries401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountries401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountries500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountries500>;

export const getApiV1LocationCountriesQueryResponseSchema = z.lazy(
  () => getApiV1LocationCountries200Schema,
) as unknown as ToZod<GetApiV1LocationCountriesQueryResponse>;
